import React, { useEffect, useState } from 'react';
import { databaseMigrationsApi, type MigrationScript, type TargetScope } from '../../../api/databaseMigrations';

interface Props {
  scope: TargetScope;
  onLoad: (scriptId: number, sql: string) => void;
}

const SavedScriptPicker: React.FC<Props> = ({ scope, onLoad }) => {
  const [scripts, setScripts] = useState<MigrationScript[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState<number | ''>('');

  useEffect(() => {
    databaseMigrationsApi.listScripts(scope)
      .then(setScripts)
      .finally(() => setLoading(false));
  }, [scope]);

  const handleLoad = async () => {
    if (!selectedId) return;
    const detail = await databaseMigrationsApi.getScript(Number(selectedId));
    onLoad(detail.script.id, detail.script.sql_content);
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-4 flex items-center gap-3">
      <span className="text-sm font-medium text-slate-700 shrink-0">Saved scripts</span>
      <select
        value={selectedId}
        onChange={(e) => setSelectedId(e.target.value === '' ? '' : Number(e.target.value))}
        disabled={loading}
        className="flex-1 px-3 py-2 border border-slate-300 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
      >
        <option value="">{loading ? 'Loading…' : '— pick a saved script —'}</option>
        {scripts.map((s) => (
          <option key={s.id} value={s.id}>
            {s.name} (v{s.version}) — {s.description || 'no description'}
          </option>
        ))}
      </select>
      <button
        type="button"
        onClick={handleLoad}
        disabled={!selectedId}
        className="px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 disabled:opacity-50"
      >
        Load
      </button>
    </div>
  );
};

export default SavedScriptPicker;
